import React from 'react';

import styled from 'styled-components';

import ShopRequestStyledSelect from '../ShopRequestStyledSelect';
import ShopRequestUserAvatar from '../ShopRequestUserAvatar';

const Container = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
`;

const StyledSelect = styled(ShopRequestStyledSelect)`
  margin-bottom: 10px;
`;

type Props = {
  value: number | null;
  onChange: (val: number) => void;
  users: Array<{ userId: number; name: string }>;
  placeholder?: string;
};

const ShopRequestModalUserSelect = ({ value, onChange, users, placeholder }: Props) => {
  return (
    <StyledSelect
      width="100%"
      options={users.map((u) => ({ value: u.userId, label: u.name }))}
      placeholder={placeholder}
      value={value}
      showSearch
      filterOption={(input, option) =>
        Boolean(option?.label) &&
        typeof option?.label === 'string' &&
        option.label.toLowerCase().includes(input.toLowerCase())
      }
      onChange={(val: number) => onChange(val)}
      labelRender={({ value, label }) => (
        <Container key={value}>
          <ShopRequestUserAvatar label={label} />
          {label}
        </Container>
      )}
    />
  );
};

export default ShopRequestModalUserSelect;
